import * as UT from "./tradeTypes";
import axios from "axios";



export const fetchTrades = () => {
  return (dispatch) => {
    dispatch(tradeRequest());
    axios
      .get(
        (process.env.REACT_APP_API_ENDPOINT ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/" : "") + "api/trade_list"
      )
      .then((response) => {
        dispatch(tradeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(userFailure(error.message));
      });
  };
};


const tradeRequest = () => {
  return {
    type: UT.USER_REQUEST,
  };
};

const tradeSuccess = (trades) => {
  console.log(trades);
  return {
    type: UT.USER_SUCCESS,
    payload: trades,
  };
};

const userFailure = (error) => {
  return {
    type: UT.USER_FAILURE,
    payload: error,
  };
};

const userSavedSuccess = (trade) => {
  return {
    type: UT.USER_SAVED_SUCCESS,
    payload: trade,
  };
};